import _str from "shared/util/_str";

export const SEND_CODE_FAILED_ERROR_MESSAGE = _str("Unable to send code. Please make sure your country code and phone number are correct.");



// WEBPACK FOOTER //
// ./src/shared/constants/sms.js